import { IMediated, ITypedQuery, IQuery, IQueryMediator, mediated_data_types } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
export * from 'utility-ts-orm';

/**
 * @what mediate query calling between sources and queries
 * @why we only want to execute queries once
 */
export class QueryMediator implements IQueryMediator {
  /**
   * call once one `run` to register all Queries
   * @deprecated
   */
  initialize(): void {
    // leave the method because we have to be backwards compatible
  }

  /**
   * @deprecated use QueryMediator#run
   */
  runQueries(...sources: (IMediated | mediated_data_types)[]): (IQuery | ITypedQuery<any>)[] {
    return ORM.run(...sources);
  }

  /**
   *
   * @param query query that needs to execute in response to a command
   * @param sources {Array} all sources
   * @returns {*} datasource
   */
  registerQuery(query: IQuery | ITypedQuery<any>, ...sources: (IMediated | mediated_data_types)[]): IQueryMediator {
    ORM.registerQuery(query, ...sources);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-kernel/src/core/query_mediator.ts